import * as React from 'react';
import { Box } from '@mui/material';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';
import QueryValuesLayout from 'src/components/Layouts/QueryValuesLayout';
import Paper from 'src/components/Paper';
import { CompaniesListWrapper } from './components/CompaniesListWrapper';
import { paths } from 'src/frontend-common/components/Router';
import { useNavigate } from 'react-router-dom';
import { GetListLimit } from 'src/dto/Limits';
import { GetCompaniesSort } from 'src/dto/Company';
import ButtonComponent from 'src/components/ButtonComponent';

interface State {
  search: string | undefined;
}

interface Props {
  limit: GetListLimit;
  setLimit: (s: GetListLimit) => void;
  page: number;
  setPage: (s: number) => void;
  sort: GetCompaniesSort;
  setSort: (s: GetCompaniesSort) => void;
}

const nameFilterInitialValue = undefined;

const CompaniesPage: React.FC<Props> = ({ page, setPage, limit, setLimit, sort, setSort }) => {
  const navigate = useNavigate();

  // Filters
  const [search, setSearch] = React.useState<State['search']>(nameFilterInitialValue);

  return (
    <DashboardPageLayout
      title="Companies"
      aside={<ButtonComponent buttontype="mainaction" text="Add New" onClick={() => navigate(`${paths.companyDetail.prePath}/new`)} />}
    >
      <Box>
        <Paper>
          <CompaniesListWrapper
            searchFilter={search}
            setSearchFilter={setSearch}
            limit={limit}
            page={page}
            setPage={setPage}
            setLimit={setLimit}
            sort={sort}
            setSort={setSort}
          />
        </Paper>
      </Box>
    </DashboardPageLayout>
  );
};

const WrappedCompaniesPage: React.FC = () => (
  <QueryValuesLayout excludeValues={['dateRange', 'token', 'tab']}>
    {({ limit, setLimit, page, setPage, sort, setSort }) => (
      <CompaniesPage limit={limit} setLimit={setLimit} page={page} setPage={setPage} sort={sort} setSort={setSort} />
    )}
  </QueryValuesLayout>
);
export { WrappedCompaniesPage as CompaniesPage };
